import React from "react";
import { Box } from "@mui/material";

export default function PerformanceItem({ title, value }) {
  return (
    <Box>
      <Box
        as="p"
        sx={{
          color: "rgb(18, 38, 27)",
          fontFamily: "FustatExtraBold",
          fontSize: "24px",
          mb: 0,
        }}
      >
        {value}
      </Box>
      <Box
        as="p"
        sx={{
          color: "rgb(138, 147, 138)",
          fontFamily: "FustatSemiBold",
          fontSize: "12px",
          m: 0,
        }}
      >
        {title}
      </Box>
    </Box>
  );
}
